import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    margin: { margin: '1rem 0' },
    text: {
        color: theme?.app?.applicationColors.fontDetailColor ||
            '#4A4C50'
    },
    textWithClient: { marginRight: '.4rem' },
    textNoClient: { marginRight: '.75rem' },
    clientContainers: { width: 'fit-content' as const },
    logoClientTpayContainer: {
        height: '22px',
        paddingTop: '0.5rem'
    },
    tassatLogoHorizontal: { height: '22px' },
    tassatPayLogoHorizontal: { height: '22px' },
    logoVertical: {
        height: '3rem',
        width: '15rem',
        paddingTop: '1rem'
    },
    logoWithClient: {
        height: '1.5rem',
        width: '7rem'
    },
    rootLogo: {
        width: '100%',
        height: '100%'
    }
}));